const defaultRegion = KSC_SECNET_CONSOLE.ENV === 'prod' ? 'cn-beijing-6' : 'cn-qingyangtest-1';

export default defaultRegion
